import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const configurationPrStringSliceName = "configurationPrString";

export type ConfigurationPrStringState = string | null;

const initialState: ConfigurationPrStringState = null;

const configurationPrStringSlice = createSlice({
  name: configurationPrStringSliceName,
  initialState: initialState as ConfigurationPrStringState,
  reducers: {
    setConfigurationPrString(_, action: PayloadAction<string>) {
      return action.payload;
    },
    resetConfigurationPrString() {
      return null;
    },
  },
});

export interface ConfigurationPrStringRootState {
  [configurationPrStringSliceName]: ConfigurationPrStringState;
}

export const selectConfigurationPrString = (state: ConfigurationPrStringRootState) => state[configurationPrStringSliceName];

export const { setConfigurationPrString, resetConfigurationPrString } = configurationPrStringSlice.actions;
export const configurationPrStringReducer = configurationPrStringSlice.reducer;
